var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$style.wrapper},[_c('BaseNumber',{style:({ opacity: 0 }),attrs:{"number":_vm.to,"decimals":_vm.decimals}}),_c('BaseNumber',{class:_vm.$style.current,style:({
      opacity: _vm.started ? 1 : 0,
      right: _vm.align === 'right' ? 0 : 'auto',
      left: _vm.align === 'left' ? 0 : 'auto',
    }),attrs:{"number":_vm.current,"decimals":_vm.decimals}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }